import script from "./ImageEditor.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImageEditor.vue?vue&type=script&setup=true&lang=ts"

import "./ImageEditor.vue?vue&type=style&index=0&id=9d3ab388&lang=scss"

const __exports__ = script;

export default __exports__